import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from './routes/ProtectedRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Callback from './pages/Callback'
import Dashboard from './pages/Dashboard'
import AccountsList from './pages/accounts/AccountsList'
import AccountDetails from './pages/accounts/AccountDetails'
import AccountsBalances from './pages/accounts/AccountsBalances'
import OnboardingsList from './pages/onboardings/OnboardingsList'
import OnboardingDetails from './pages/onboardings/OnboardingDetails'
import OnboardingPfDetails from './pages/onboardings/OnboardingPfDetails'
import PayingAgentsList from './pages/payingAgents/PayingAgentsList'
import PayingAgentDetails from './pages/payingAgents/PayingAgentDetails'
import PayingAgentBoleto from './pages/payingAgents/PayingAgentBoleto'
import Utils from './pages/utils/Utils'
import PlansList from './pages/PlansList'
import PlanDetails from './pages/PlanDetails'

function App() {
	return (
		<Router>
			<div className="App">
				<Routes>
					<Route path="/login" element={<Login />} />
					<Route path="/callback" element={<Callback />} />

					<Route
						element={
							<ProtectedRoute>
								<Layout />
							</ProtectedRoute>
						}
					>
						<Route index element={<Dashboard />} />

						<Route path="contas" element={<AccountsList />} />
						<Route path="saldos-qitech" element={<AccountsBalances />} />
						<Route path="contas/:id" element={<AccountDetails />} />

						<Route path="onboardings" element={<OnboardingsList />} />
						<Route path="onboardings/pj/:id" element={<OnboardingDetails />} />
						<Route path="onboardings/pf/:id" element={<OnboardingPfDetails />} />

						<Route path="pagadoria" element={<PayingAgentsList />} />
						<Route path="pagadoria/boletos" element={<PayingAgentBoleto />} />
						<Route path="pagadoria/:onboardingId" element={<PayingAgentDetails />} />

						<Route path="utils" element={<Utils />} />

						{/* telas legadas de planos, fora do menu */}
						<Route path="plans" element={<PlansList />} />
						<Route path="plans/:id" element={<PlanDetails />} />

						<Route path="*" element={<Navigate to="/" replace />} />
					</Route>
				</Routes>
			</div>
		</Router>
	)
}

export default App
